import { Button } from 'antd'
import { useTranslation } from 'react-i18next'

export default function Error404Page() {
    const { t } = useTranslation()
    return (
        <div
            style={{
                backgroundImage: 'url("/assets/errors/error404.svg")',
                backgroundRepeat: 'no-repeat',
                backgroundPositionX: 'center',
                backgroundColor: 'var(--ant-color-bg-layout)',
                width: '100%',
                height: '100vh',
                display: 'flex',
                justifyContent: 'flex-end',
                padding: '25px',
            }}
        >
            <Button type="primary" onClick={() => (window.location.href = '/')}>
                {t('To Home page')}
            </Button>
        </div>
    )
}
